import SectionHub from '@/components/docs/SectionHub';

export default function Docs04MacrosAndSignalsNewsHub() {
  return <SectionHub sectionPath="04-macros-and-signals/news" />;
}
